import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/shell/AppShell';

/**
 * Pathless layout guarding every nested route. Redirects unauthenticated users
 * to /sign-in before any child component mounts, then wraps the routed page in
 * the AppShell (sidebar + header) so all authenticated pages share the chrome.
 */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isSignedIn) {
      throw redirect({ to: '/sign-in', search: { redirect: location.href } });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
